import { useContext } from 'react';
import { useNavigate } from 'react-router-dom';
import { Avatar, Button, Grid, Link, Text } from '@ltvco/refresh-lib/theme';
import { AppConstants } from '@ltvco/refresh-lib/ctx';
import { useSession } from '@ltvco/refresh-lib/v1';
import { SidenavContainer } from 'components/sidenav/SidenavContainer';
import warning from '../images/img_warning.svg';

export function ErrorPage() {
  const navigate = useNavigate();
  const {
    data: { supportEmail },
  } = useContext(AppConstants);
  const { isAuthenticated } = useSession().session;

  function goToDashboard() {
    navigate('/dashboard/home');
  }

  function goToLogin() {
    navigate('/login');
  }

  const Container = isAuthenticated ? SidenavContainer : Grid;
  const navigateFunction = isAuthenticated ? goToDashboard : goToLogin;
  const navigateTo = isAuthenticated ? 'dashboard/home' : 'login';

  return (
    <Container>
      <Grid container spacing={3} textAlign={'center'} marginTop={8}>
        <Grid size={12}>
          <Avatar
            src={warning}
            alt="404"
            sx={{ width: 95, height: 80, margin: 'auto' }}
            variant="square"
          />
          <Text variant="h2" fontSize={52} marginTop={2.5}>
            Whoops!
          </Text>
          <Text variant="h3" fontSize={24} marginTop={2.5}>
            Looks like something went wrong.
          </Text>
          <Text margin={'auto'}>
            We apologize for the inconvenience; please contact{' '}
            <Link href={`mailto:${supportEmail}`}>{supportEmail}</Link> if this
            problem persists.
          </Text>
          <Button
            variant="contained"
            sx={{ marginTop: 2.5 }}
            onClick={navigateFunction}
          >
            Go to {navigateTo}
          </Button>
        </Grid>
      </Grid>
    </Container>
  );
}
